import { UserControllerService } from '@core/services/outros/user-controller.service';
import { Subscription } from 'rxjs';
import { NotificationCFCService } from '@core/services/apis/gestao/notification-cfc.service';
import { NotificacaoCFCModel } from '@core/models/gestao/notificacao-cfc.model';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { CriticalityLevelEnum } from '@core/enums/criticality-level.enum';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, AfterViewInit {

  notifications: Array<NotificacaoCFCModel> = [];
  filterNotifications = {
    cfcId: 0,
    lido: false,
    situacao: 'PUBLICADA'
  };
  private _subscription: Subscription;

  constructor(
    private _notificationCfcService: NotificationCFCService,
    private _userService: UserControllerService,
  ) {
    this._subscription = new Subscription();
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.getNotifications();
  }

  getNotifications(): void {
    this.filterNotifications.cfcId = this._userService.getUserLogged().cfc.id;
    this._subscription.add(
      this._notificationCfcService.getAll(this.filterNotifications).subscribe(
        (res: Array<NotificacaoCFCModel>) => {
          let newNotifications = res.filter(x => x.notificacao.nivelCriticidade != CriticalityLevelEnum.HIGH);
          this.notifications = this.notifications.concat(newNotifications);
        }
      )
    );
  }

  onRead(notification: NotificacaoCFCModel): void {
    notification.lido = true;

    this._subscription.add(
      this._notificationCfcService.saveRead(notification).subscribe(
        () => {
          this.notifications = this.notifications.filter(item => item != notification)
        })
    );
  }

  getCountUnreadNotifications() {
    return this.notifications?.filter(x => !x.lido).length;
  }

  readAllNotifications() {
    this.notifications.forEach(item => {
      if (!item.lido)
        this.onRead(item);
    });
  }


}
